export const messages = Object.freeze({
    alert_is_none: 'A required alert value is missing from the request.',
    aluid_is_none: 'A required value is missing. Refresh the page and try again.',
    api_key_delete_unauthorized: "You can't delete this API key.",
    auth0_user_creation_error: 'Your account could not be created. Please try again or contact support.',
    auth_token_missing: 'The auth token is missing or could not be found.',
    dropbox_not_linked: 'Link your Dropbox account before using this action.',
    env_var_missing: 'The env var is missing or could not be found.',
    failed_to_delete_user_status_temp_file: 'Failed to delete user status temp file. Please try again or contact support.',
    filesystem_error: 'The file operation could not be completed. Please try again or contact support.',
    filesystem_path_error: 'The file operation could not be completed. Please try again or contact support.',
    invalid_include_editor_names_request: 'Invalid include editor names request. Please check your input and try again.',
    invalid_secret_type: 'Invalid secret type. Please check your input and try again.',
    invalid_sf_user_type: 'Invalid Tables user type. Please check your input and try again.',
    mailgun_email_send_failed: 'The email could not be sent. Please try again or contact support.',
    missing_current_user_connection: 'Required current user connection is missing.',
    missing_oid: 'Required organization is missing.',
    missing_rpid: 'Required resource pool is missing.',
    missing_sf_user_type: 'Required Tables user type is missing.',
    missing_sid: 'Required space is missing.',
    name_invalid: 'Invalid name. Please check your input and try again.',
    newsletter_not_found: 'The requested newsletter could not be found.',
    nlid_is_none: 'A required value is missing. Refresh the page and try again.',
    no_secret_found: 'No secret was found. Please check your selection and try again.',
    personal_env_var_unauthorized: "You can't access this environment variable.",
    personal_secret_unauthorized: "You can't access this secret.",
    secret_reference_invalid: 'Invalid secret reference. Please check your input and try again.',
    tknid_is_none: 'A required value is missing. Refresh the page and try again.',
    token_missing: 'The token is missing or could not be found.',
    unexpected_exception: "We couldn't load your user profile. Please log in again.",
    unidentifiable_secret_request: 'The request could not be processed because a required identifier is missing.',
    unidentifiable_token_id: 'The token could not be identified.',
    user_conn_null: 'Your session is invalid. Please log in again.',
    user_connection_not_found: 'The requested user connection could not be found.',
    user_not_found: 'The requested user could not be found.',
    user_not_found_by_ucid: 'The requested user could not be found.',
    user_not_found_by_username: 'The requested user could not be found.',
    user_null: 'Your session is invalid. Please log in again.'
})

export const dialogs = Object.freeze({
    email_already_registered_error: {
        dialogTitle: 'Existing account',
        dialogText: 'An account already exists with this email address. Please sign in with the existing account to accept your invitation.',
        dialogAction: ['dismiss']
    },
    ssh_token_limit_reached: {
        dialogTitle: "Can't add new ssh token!",
        dialogText: 'The SSH token limit has been reached. Remove an unused token before adding another.',
        dialogAction: ['close']
    }
})
